import * as React from "react";
import { Button } from "@grandvisionhq/common";
/* empty css                                                         */
const RemoveButton = (props) => /* @__PURE__ */ React.createElement(
  Button,
  {
    size: "custom",
    "data-t": "remove-button",
    className: "remove-button",
    variant: "ghost",
    ...props
  }
);
export {
  RemoveButton
};
//# sourceMappingURL=RemoveButton.js.map
